import { render, staticRenderFns } from "./action_codes.vue?vue&type=template&id=56b82017&scoped=true&"
import script from "./action_codes.vue?vue&type=script&lang=js&"
export * from "./action_codes.vue?vue&type=script&lang=js&"
import style0 from "./action_codes.vue?vue&type=style&index=0&id=56b82017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b82017",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b82017')) {
      api.createRecord('56b82017', component.options)
    } else {
      api.reload('56b82017', component.options)
    }
    module.hot.accept("./action_codes.vue?vue&type=template&id=56b82017&scoped=true&", function () {
      api.rerender('56b82017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/actions/modal/tabs/action_codes.vue"
export default component.exports